export const es = {
  components: {
    datePicker: {
      openCalendar: 'Abrir calendario',
      clear: 'Borrar rango de fechas',
    },
    dataGrid: {
      selectAll: 'Seleccionar todo',
      selectRow: 'Seleccionar fila',
      noData: 'No hay datos disponibles',
      error: 'Error al cargar datos',
      errorDescription: 'Por favor, inténtelo de nuevo en unos minutos',
    },
    select: {
      noOptions: 'No se encontraron opciones',
    },
    sidecarSelector: {
      label: 'Sidecar',
      noSelection: 'Sin sidecar seleccionado',
      online: '[en línea]',
      offline: '[sin conexión]',
      connecting: 'Conectando',
      direct: 'Directo',
      relay: 'Relay',
      disconnected: 'Desconectado',
    },
    cameraStream: {
      loading: 'Conectando...',
      unavailable: 'Transmisión no disponible',
      menuLabel: 'Opciones de transmisión',
      ptz: {
        left: 'Girar a la izquierda',
        right: 'Girar a la derecha',
        up: 'Inclinar arriba',
        down: 'Inclinar abajo',
        zoomIn: 'Acercar',
        zoomOut: 'Alejar',
      },
      floodlight: {
        on: 'Encender reflector',
        off: 'Apagar reflector',
      },
      siren: {
        trigger: 'Activar sirena',
      },
    },
    loading: 'Cargando...',
    saving: 'Guardando...',
    saved: 'Cambios guardados',
    photoCard: {
      uploading: 'Subiendo...',
      uploadFailed: 'Error al subir',
      noImage: 'Sin imagen',
    },
  },
};
